import StakeholderService from "JS/services/campaign/StakeholderService";

const STAKEHOLDERS_LIMIT = 15

export default class infiniteScrollHelper {
  constructor(store, router, eventsBus) {
    this.store = store;
    this.router = router;
    this.eventsBus = eventsBus;

    // "last batch" refers to the number of results retrieved from the most recent call
    this.searchStakeholdersLastBatch = 0
    this.searchStakeholdersOffset = 0

    this.stakeholderService = new StakeholderService(store, router, eventsBus)
  }

  // Trigger the call when the user has scrolled past the container's halfway point
  detectBottomOfElement(event) {
    return event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight - event.target.scrollHeight / 2;
  }

  async fetchMoreSearchStakeholders(searchTerm) {
    this.eventsBus.$emit("infiniteScrollLoading", true)

    // Since we've already received the first batch of results if we're here, set the offset to the limit plus the previous offset
    this.searchStakeholdersOffset = this.searchStakeholdersOffset + STAKEHOLDERS_LIMIT;
    let newSearchStakeholders = await this.stakeholderService.findByName(searchTerm, this.searchStakeholdersOffset)
    this.updateSearchStakeholdersLastBatch(newSearchStakeholders)

    this.eventsBus.$emit("infiniteScrollLoading", false)
    return newSearchStakeholders
  }

  moreSearchStakeholdersAvailable(searchStakeholdersVisible) {
    return searchStakeholdersVisible && this.searchStakeholdersLastBatch >= STAKEHOLDERS_LIMIT
  }

  updateSearchStakeholdersLastBatch(searchStakeholders) {
    this.searchStakeholdersLastBatch = searchStakeholders.length
    return
  }

}